import { LearnerForm, LearnerFormType, parseLearnerFormToBackend } from './LearnerForm.tsx'

import { useDataProvider, useNotify } from 'react-admin'

import styles from './LearnerForm.module.scss'
import { useSubmitLoader } from '@src/logic/contexts/utils/SubmitContext.tsx'
import { useDocumentTitle } from '@src/hooks/useDocumentTitle.ts'
import { LearnerF } from '@src/logic/contexts/Learners/LearnersFrontend.type.ts'
import Dialog from '@mui/material/Dialog'
import { useModal } from '@src/logic/contexts/Modal/ModalContext.tsx'
import { cn } from '@src/utils/cn.ts'

type UserProps = {
  learner: LearnerF
  onUpdated?: () => void
}

export const LearnerEdit: React.FC<UserProps> = ({ learner, onUpdated }) => {
  useDocumentTitle('Edit ' + learner?.fullName)
  const dataProvider = useDataProvider()
  const notify = useNotify()
  const { isFormSubmitting, setIsFormSubmitting } = useSubmitLoader()
  const { hideModal } = useModal()

  const onSubmit = async (formData: LearnerFormType) => {
    if (isFormSubmitting) {
      return
    }

    setIsFormSubmitting(true)

    try {
      await dataProvider.update('Learner', {
        id: formData.id,
        data: parseLearnerFormToBackend(formData),
        previousData: null,
      })
      // // Handle success case
      notify('Learner updated successfully', { type: 'success' })
      onUpdated?.()
      clearAndClose()
    } catch (error) {
      const errorMessage = error.message || 'Something went wrong, Please try again after sometime'
      notify(errorMessage, { type: 'error' })
    } finally {
      setIsFormSubmitting(false)
    }
  }

  const clearAndClose = () => {
    // localStorage.removeItem(`${learner?.id}-learnerEditForm`)
    hideModal()
  }

  const handleDialogClose = (_: unknown, reason?: 'backdropClick' | 'escapeKeyDown') => {
    if (reason === 'backdropClick') return
    clearAndClose()
  }

  return (
    <Dialog open onClose={handleDialogClose} role='dialog' aria-labelledby='edit-learner-dialog-title' maxWidth='md' fullWidth>
      <div className={styles.dialogHeader}>
        <h3 id='edit-learner-dialog-title'>Edit {learner?.fullName}</h3>
      </div>
      <div data-page='edit-learner-modal' className={cn(styles.dialogContent)}>
        <LearnerForm learner={learner} onSubmit={onSubmit} onCancel={clearAndClose} isEdit={true} isSubmitting={isFormSubmitting} />
      </div>
    </Dialog>
  )
}
